import { ServiceUnit } from '@/types';
import { Core, SERVICE_UNITS } from '../Core';

class ServiceUnits extends Core {
  getServiceUnits = async () => this.get<ServiceUnit[]>(SERVICE_UNITS());

  updateServiceUnits = async (data: ServiceUnit) =>
    this.patch(SERVICE_UNITS(), data);

  createServiceUnits = async (data: ServiceUnit) =>
    this.put(SERVICE_UNITS(), data);
}

export const serviceUnits = new ServiceUnits();
